import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Switch } from "./ui/switch";
import { Send, Search, Save } from "lucide-react";

export const TelegramCard = ({ s, setS, onSaved }) => {
  const [busy, setBusy] = useState("");

  const persist = async (patch) => {
    setBusy("save");
    try {
      const { data } = await api.put("/settings", patch);
      setS(data);
      onSaved?.();
      toast.success("Pengaturan Telegram disimpan");
    } catch (e) {
      toast.error(errMsg(e, "Gagal menyimpan"));
    } finally {
      setBusy("");
    }
  };

  const detect = async () => {
    setBusy("detect");
    try {
      const { data } = await api.post("/telegram/detect", {
        token: (s.telegram_token || "").includes("…") ? "" : s.telegram_token || "",
      });
      setS({ ...s, telegram_chat_id: data.chat_id });
      toast.success(`Chat terdeteksi: ${data.title || data.chat_id}`);
    } catch (e) {
      toast.error(errMsg(e, "Gagal mendeteksi Chat ID"));
    } finally {
      setBusy("");
    }
  };

  const test = async () => {
    setBusy("test");
    try {
      const { data } = await api.post("/telegram/test", {});
      toast.success(
        data.ok ? `Pesan uji terkirim via @${data.bot}` : "Pesan uji gagal terkirim"
      );
    } catch (e) {
      toast.error(errMsg(e, "Gagal mengirim pesan uji"));
    } finally {
      setBusy("");
    }
  };

  return (
    <div
      className="bg-white border border-gray-200 rounded-2xl p-5 space-y-4"
      data-testid="telegram-card"
    >
      <div className="flex items-center justify-between gap-3">
        <p className="font-display font-semibold flex items-center gap-2">
          <Send size={18} className="text-primary" /> Laporan ke Telegram
        </p>
        <Switch
          data-testid="telegram-enabled-switch"
          checked={s.telegram_enabled !== false}
          onCheckedChange={(v) => persist({ telegram_enabled: v })}
        />
      </div>
      <p className="text-xs text-muted-foreground">
        Langkah 1: buat bot di Telegram lewat <b>@BotFather</b> → kirim <code>/newbot</code> → salin
        token. Langkah 2: tempel token di kolom bawah lalu klik <b>Simpan Telegram</b>. Langkah 3:
        kirim <code>/start</code> ke bot Anda, klik <b>Deteksi Chat ID</b>, simpan sekali lagi, lalu
        <b> Kirim Pesan Uji</b>. Setelah itu rekap harian otomatis terkirim tiap 22:00 JST.
      </p>
      <Input
        data-testid="telegram-token-input"
        placeholder="Token bot (123456:ABC-...)"
        value={s.telegram_token || ""}
        onChange={(e) => setS({ ...s, telegram_token: e.target.value })}
      />
      <div className="flex flex-col sm:flex-row gap-2">
        <Input
          data-testid="telegram-chat-id-input"
          placeholder="Chat ID tujuan"
          value={s.telegram_chat_id || ""}
          onChange={(e) => setS({ ...s, telegram_chat_id: e.target.value })}
        />
        <Button
          variant="outline"
          data-testid="telegram-detect-btn"
          disabled={busy === "detect"}
          onClick={detect}
        >
          <Search size={15} className="mr-1" /> Deteksi Chat ID
        </Button>
      </div>
      <label className="flex items-center justify-between text-sm gap-3">
        <span>Sertakan angka laba & belanja stok</span>
        <Switch
          data-testid="telegram-profit-switch"
          checked={s.telegram_include_profit !== false}
          onCheckedChange={(v) => setS({ ...s, telegram_include_profit: v })}
        />
      </label>
      <div className="flex flex-wrap gap-2">
        <Button
          data-testid="telegram-save-btn"
          disabled={busy === "save"}
          onClick={() =>
            persist({
              telegram_token: s.telegram_token || "",
              telegram_chat_id: s.telegram_chat_id || "",
              telegram_include_profit: s.telegram_include_profit !== false,
            })
          }
        >
          <Save size={15} className="mr-1" /> Simpan Telegram
        </Button>
        <Button
          variant="outline"
          data-testid="telegram-test-btn"
          disabled={busy === "test"}
          onClick={test}
        >
          <Send size={15} className="mr-1" /> Kirim Pesan Uji
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">
        Otomatis terkirim: rekap harian 22:00 JST, rekap mingguan Senin 08:00 JST, pesanan online
        baru & perubahan status, serta peringatan stok menipis.
      </p>
    </div>
  );
};
